#import "../fragments/activity-for-modal-fragment.graphql"

query GetActivityForModal($activityId: ID!) {
    activity(id: $activityId) {
        ...ActivityModalFragment
    }
}
